export const TOKENS = {
    1: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48": {
            "name": "USDCoin",
            "address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            "symbol": "USDC",
            "nameLower": "usdcoin",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0xdac17f958d2ee523a2206206994597c13d831ec7": {
            "address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
            "name": "Tether",
            "symbol": "USDT",
            "nameLower": "tether",
            "symbolLower": "usdt",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/325/large/Tether.png"
        },
        "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599": {
            "name": "Wrapped BTC",
            "symbol": "WBTC",
            "address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
            "symbolLower": "wbtc",
            "nameLower": "wrapped btc",
            "decimals": 8,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
        },
        "0x6982508145454ce325ddbe47a25d4ec3d2311933": {
            "name": "Pepe",
            "address": "0x6982508145454ce325ddbe47a25d4ec3d2311933",
            "symbol": "PEPE",
            "decimals": 18,
            "logoURI": "https://assets.coingecko.com/coins/images/29850/large/pepe-token.jpeg",
            "nameLower": "pepe",
            "symbolLower": "pepe",
        },
        "0x6b175474e89094c44da98b954eedeac495271d0f": {
            "address": "0x6b175474e89094c44da98b954eedeac495271d0f",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
            "name": "Dai Stablecoin",
            "symbol": "DAI",
            "nameLower": "dai stablecoin",
            "symbolLower": "dai"
        }
    },
    5: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0xd87ba7a50b2e7e660f678a895e4b72e7cb4ccd9c": {
            "name": "USDCoin",
            "address": "0xd87ba7a50b2e7e660f678a895e4b72e7cb4ccd9c",
            "symbol": "USDC",
            "nameLower": "usdcoin",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0xdc31ee1784292379fbb2964b3b9c4124d8f89c60": {
            "address": "0xdc31ee1784292379fbb2964b3b9c4124d8f89c60",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
            "name": "Dai Stablecoin",
            "symbol": "DAI",
            "nameLower": "dai stablecoin",
            "symbolLower": "dai"
        },
        "0xc04b0d3107736c32e19f1c62b2af67be61d63a05": {
            "name": "Wrapped BTC",
            "address": "0xc04b0d3107736c32e19f1c62b2af67be61d63a05",
            "symbolLower": "wbtc",
            "nameLower": "wrapped btc",
            "symbol": "WBTC",
            "decimals": 8,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
        }
    },
    42161: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0xaf88d065e77c8cc2239327c5edb3a432268e5831": {
            "name": "USDCoin",
            "address": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
            "symbol": "USDC",
            "nameLower": "usdcoin",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8": {
            "name": "Bridged USDCoin",
            "address": "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
            "symbol": "USDC.e",
            "nameLower": "bridged usdcoin",
            "symbolLower": "usdc.e",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9": {
            "address": "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
            "name": "Tether",
            "symbol": "USDT",
            "nameLower": "tether",
            "symbolLower": "usdt",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/325/large/Tether.png"
        },
        "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f": {
            "name": "Wrapped BTC",
            "symbol": "WBTC",
            "address": "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
            "symbolLower": "wbtc",
            "nameLower": "wrapped btc",
            "decimals": 8,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
        },
        "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1": {
            "address": "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
            "name": "Dai Stablecoin",
            "symbol": "DAI",
            "nameLower": "dai stablecoin",
            "symbolLower": "dai"
        },
        "0x912ce59144191c1204e64559fe8253a0e49e6548": {
            "address": "0x912ce59144191c1204e64559fe8253a0e49e6548",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1/logo.png",
            "name": "Arbitrum",
            "symbol": "ARB",
            "nameLower": "arbitrum",
            "symbolLower": "arb"
        },
    },
    421613: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0xc944b73fba33a773a4a07340333a3184a70af1ae": {
            "name": "USDCoin",
            "address": "0xc944b73fba33a773a4a07340333a3184a70af1ae",
            "symbol": "USDC",
            "nameLower": "usdcoin",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        }
    },
    7700: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Canto",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "CANTO",
            "nameLower": "native canto",
            "symbolLower": "canto",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg"
        },
        "0xee602429ef7ece0a13e4ffe8dbc16e101049504c": {
            "name": "cNote",
            "address": "0xee602429ef7ece0a13e4ffe8dbc16e101049504c",
            "symbol": "cNOTE",
            "nameLower": "cnote",
            "symbolLower": "cnote",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/Plex-Engineer/public-assets/main/icons/tokens/cNote.svg"
        },
        "0x80b5a32e4f032b2a058b4f29ec95eefeeb87adcd": {
            "name": "USDC via channel 0",
            "address": "0x80b5a32e4f032b2a058b4f29ec95eefeeb87adcd",
            "symbol": "USDC",
            "nameLower": "usdc via channel 0",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
    },
    534351: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x4d65fb724ced0cfc6abfd03231c9cdc2c36a587b": {
            "name": "Bridged USDCoin (Scroll)",
            "address": "0x4d65fb724ced0cfc6abfd03231c9cdc2c36a587b",
            "symbol": "USDC",
            "nameLower": "bridged usdcoin (scroll)",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
    },
    81457: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x4300000000000000000000000000000000000003": {
            "name": "USDB",
            "address": "0x4300000000000000000000000000000000000003",
            "symbol": "USDB",
            "nameLower": "usdb",
            "symbolLower": "usdb",
            "decimals": 18,
            "logoURI": "https://assets.coingecko.com/coins/images/35595/large/65c67f0ebf2f6a1bd0feb13c_usdb-icon-yellow.png"
        },
    },
    168587773: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x4300000000000000000000000000000000000003": {
            "name": "USDB",
            "address": "0x4300000000000000000000000000000000000003",
            "symbol": "USDB",
            "nameLower": "usdb",
            "symbolLower": "usdb",
            "decimals": 18,
            "logoURI": "https://assets.coingecko.com/coins/images/35595/large/65c67f0ebf2f6a1bd0feb13c_usdb-icon-yellow.png"
        },
    },
    534352: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x06efdbff2a14a7c8e15944d1f4a48f9f95f663a4": {
            "name": "Bridged USDCoin (Scroll)",
            "address": "0x06efdbff2a14a7c8e15944d1f4a48f9f95f663a4",
            "symbol": "USDC",
            "nameLower": "bridged usdcoin (scroll)",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0xf55bec9cafdbe8730f096aa55dad6d22d44099df": {
            "name": "Bridged Tether (Scroll)",
            "address": "0xf55bec9cafdbe8730f096aa55dad6d22d44099df",
            "symbol": "USDT",
            "nameLower": "bridged tether (scroll)",
            "symbolLower": "usdt",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/325/large/Tether.png"
        },
        "0x3c1bca5a656e69edcd0d4e36bebb3fcdaca60cf1": {
            "name": "Bridged Wrapped BTC (Scroll)",
            "symbol": "WBTC",
            "address": "0x3c1bca5a656e69edcd0d4e36bebb3fcdaca60cf1",
            "symbolLower": "wbtc",
            "nameLower": "bridged wrapped btc (scroll)",
            "decimals": 8,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
        },
    },
    1923: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34": {
            "name": "USDe",
            "address": "0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34",
            "symbol": "USDe",
            "nameLower": "usde",
            "symbolLower": "usde",
            "decimals": 18,
            "logoURI": "https://assets.coingecko.com/coins/images/33613/standard/usde.png"
        },
        "0x2826d136f5630ada89c1678b64a61620aab77aea": {
            "name": "SWELL",
            "address": "0x2826d136f5630ada89c1678b64a61620aab77aea",
            "symbol": "SWELL",
            "nameLower": "swell",
            "symbolLower": "swell",
            "decimals": 18,
            "logoURI": "https://assets.coingecko.com/coins/images/28777/standard/swell1.png?1727899715"
        },
    },
    98865: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Native Ether",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "ETH",
            "nameLower": "native ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0x3938a812c54304feffd266c7e2e70b48f9475ad6": {
            "name": "Bridged USDC (Stargate)",
            "address": "0x3938a812c54304feffd266c7e2e70b48f9475ad6",
            "symbol": "USDC.e",
            "nameLower": "bridged usdc (stargate)",
            "symbolLower": "usdc.e",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
    },
    10143: {
        "0x0000000000000000000000000000000000000000": {
            "name": "Monad Testnet MON",
            "address": "0x0000000000000000000000000000000000000000",
            "symbol": "MON",
            "nameLower": "monad testnet mon",
            "symbolLower": "mon",
            "decimals": 18,
            "logoURI": "https://img.cryptorank.io/coins/150x150.monad1710498467135.png"
        },
        "0x836047a99e11f376522b447bffb6e3495dd0637c": {
            "name": "Bridged Ether",
            "address": "0x836047a99e11f376522b447bffb6e3495dd0637c",
            "symbol": "ETH",
            "nameLower": "bridged ether",
            "symbolLower": "eth",
            "decimals": 18,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
        },
        "0xb5a30b0fdc5ea94a52fdc42e3e9760cb8449fb37": {
            "name": "Wrapped Ether",
            "address": "0xb5a30b0fdc5ea94a52fdc42e3e9760cb8449fb37",
            "symbol": "WETH",
            "nameLower": "wrapped ether",
            "symbolLower": "weth",
            "decimals": 18,
            "logoURI": "https://etherscan.io/token/images/weth_28.png"
        },
        "0xf817257fed379853cde0fa4f97ab987181b1e5ea": {
            "name": "USDCoin",
            "address": "0xf817257fed379853cde0fa4f97ab987181b1e5ea",
            "symbol": "USDC",
            "nameLower": "usdcoin",
            "symbolLower": "usdc",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
        },
        "0x88b8e2161dedc77ef4ab7585569d2415a1c1055d": {
            "address": "0x88b8e2161dedc77ef4ab7585569d2415a1c1055d",
            "name": "Tether",
            "symbol": "USDT",
            "nameLower": "tether",
            "symbolLower": "usdt",
            "decimals": 6,
            "logoURI": "https://assets.coingecko.com/coins/images/325/large/Tether.png"
        },
        "0xcf5a6076cfa32686c0df13abada2b40dec133f1d": {
            "name": "Wrapped BTC",
            "symbol": "WBTC",
            "address": "0xcf5a6076cfa32686c0df13abada2b40dec133f1d",
            "symbolLower": "wbtc",
            "nameLower": "wrapped btc",
            "decimals": 8,
            "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
        },
        "0x0f0bdebf0f83cd1ee3974779bcb7315f9808c714": {
            "name": "Molandak",
            "symbol": "DAK",
            "address": "0x0f0bdebf0f83cd1ee3974779bcb7315f9808c714",
            "symbolLower": "dak",
            "nameLower": "molandak",
            "decimals": 18,
            "logoURI": "https://imagedelivery.net/tWwhAahBw7afBzFUrX5mYQ/27759359-9374-4995-341c-b2636a432800/public"
        },
        "0xfe140e1dce99be9f4f15d657cd9b7bf622270c50": {
            "name": "Moyaki",
            "symbol": "YAKI",
            "address": "0xfe140e1dce99be9f4f15d657cd9b7bf622270c50",
            "symbolLower": "yaki",
            "nameLower": "moyaki",
            "decimals": 18,
            "logoURI": "https://imagedelivery.net/tWwhAahBw7afBzFUrX5mYQ/6679b698-a845-412b-504b-23463a3e1900/public"
        },
        "0xe0590015a873bf326bd645c3e1266d4db41c4e6b": {
            "name": "Chog",
            "symbol": "CHOG",
            "address": "0xe0590015a873bf326bd645c3e1266d4db41c4e6b",
            "symbolLower": "chog",
            "nameLower": "chog",
            "decimals": 18,
            "logoURI": "https://imagedelivery.net/tWwhAahBw7afBzFUrX5mYQ/5d1206c2-042c-4edc-9f8b-dcef2e9e8f00/public"
        }
    },
}
